import {
  combine,
  withCallbacks,
  withContext,
  withState,
  withAsyncEffect,
} from 'react-hooks-combine'

import { withFormModel } from 'shared/hooks'
import { ServicesContext } from 'services/context'
import { toaster } from 'utils/toast-wrapper'

import TimemachineComponent from './component'
import { formModel } from './form.model'

export const TimemachineContainer = combine(
  withContext(
    'taxonomyService',
    ServicesContext,
    ({ adminTaxonomyService }) => adminTaxonomyService
  ),
  withState('lastTimeUpdated', 'setLastTimeUpdatedAt', () => Date.now()),
  withAsyncEffect({
    deps: ['lastTimeUpdated'],
    dataName: 'tmConfig',
    async asyncAction({ taxonomyService }) {
      const [tmDates, schedulerEnabled] = await Promise.all([
        taxonomyService.getTimeMachineDates(),
        taxonomyService.isTimemachineSchedulerEnabled(),
      ])

      return {
        ...tmDates,
        schedulerEnabled,
      }
    },
  }),
  withFormModel(formModel, {
    id: 'timemachine-config-form',
    deps: ['tmConfig'],
  }),
  withCallbacks(
    {
      onSubmitRequest:
        ({ taxonomyService, setLastTimeUpdatedAt }) =>
        async ({ customDate, schedulerEnabled }) => {
          await Promise.all([
            taxonomyService.setTimeMachineCustomDate(customDate),
            taxonomyService.setTimemachineSchedulerEnabled(schedulerEnabled),
          ])

          setLastTimeUpdatedAt(Date.now())

          toaster.info('Time machine config has been successfully updated')
        },
    },
    []
  )
)(TimemachineComponent)
